exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filterGroupAccordion__accordion___2h5NE {\n  border-bottom: 1px solid #e8e8e8;\n  margin-top: 16px;\n  width: 100%; }\n\n.filterGroupAccordion__header___tISOn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 4px;\n  cursor: pointer;\n  user-select: none; }\n  .filterGroupAccordion__header___tISOn:hover {\n    background-color: rgba(0, 0, 0, 0.02); }\n\n.filterGroupAccordion__title___2OBUl {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n  margin: 20px 0 10px; }\n\n.filterGroupAccordion__chevron___30cWa {\n  font-size: 12px;\n  color: #828282;\n  margin-left: 8px;\n  flex-shrink: 0; }\n\n.filterGroupAccordion__body___3fENM {\n  padding: 8px 0 16px; }\n", ""]);

// exports
exports.locals = {
	"accordion": "filterGroupAccordion__accordion___2h5NE",
	"header": "filterGroupAccordion__header___tISOn",
	"title": "filterGroupAccordion__title___2OBUl",
	"chevron": "filterGroupAccordion__chevron___30cWa",
	"body": "filterGroupAccordion__body___3fENM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SearchControls/SearchGroups/FilterGroupAccordion/filterGroupAccordion.scss
// module id = 4211
// module chunks = 6